import React, {Component, useState} from "react";

import WithUserData from "../WithUserData";
import {MdOutlineArrowBackIos} from "react-icons/md";
import {Link} from "react-router-dom";
import Modal from "../../BrandSignup/Modal";

const EditProfile = () => {

    const [showFeatureComingSoonPopup, setShowFeatureComingSoonPopup] = useState(false)
    return (
        <WithUserData>
            {() => {
                const buttonClassName = "cursor-pointer w-full h-16 pl-10 border border-black text-gray-900 text-lg rounded-lg flex items-center hover:bg-gray-200 mt-0 sm:mt-3"
                return (
                    <div className='w-full h-full flex flex-col justify-between sm:justify-start'>
                        <div className="w-full h-16 flex justify-between items-center mt-6 px-2">
                            <Link
                                to="/account"
                                className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                            >
                                <div className="w-10 flex items-center justify-center">
                                    <MdOutlineArrowBackIos size={18}/>
                                </div>
                                <span>Back</span>
                            </Link>
                            <div className="text-black text-2xl font-bold mr-10">Edit Profile</div>
                        </div>
                        <div className="w-full sm:mt-20">
                            <Link
                                to="/account/contact-info"
                                className={`${buttonClassName}`}
                            >
                                Contact info
                            </Link>
                            <div className={`${buttonClassName}`}
                                 onClick={() => {
                                     setShowFeatureComingSoonPopup(true);
                                     setTimeout(() => {
                                         setShowFeatureComingSoonPopup(false)
                                     }, 2500)
                                 }}
                            >
                                Personal details
                            </div>
                            <Link
                                to="/account/skills"
                                className={`${buttonClassName}`}
                            >
                                Skills
                            </Link>
                            <div className={`${buttonClassName}`}
                                 onClick={() => {
                                     setShowFeatureComingSoonPopup(true);
                                     setTimeout(() => {
                                         setShowFeatureComingSoonPopup(false)
                                     }, 2500)
                                 }}
                            >
                                Job preferences
                            </div>
                            <Link
                                to="/account/instagram"
                                className={`${buttonClassName}`}
                            >
                                Instagram connect
                            </Link>
                        </div>
                        <Modal isOpenModal={showFeatureComingSoonPopup} light={true}>
                            This functionality will be available soon
                        </Modal>
                    </div>
                )
            }}
        </WithUserData>
    );
}
export default EditProfile;